import { useAppSelector } from 'redux-store/hooks';
import { Language } from 'types/language';

export type langType = Language;
export const useGetLang = (): langType => {
    const lang = useAppSelector(state => state.locale.lang);

    return lang;
};
